<template>
  <div v-if="interests && interests.length" id="ProfileHighlightsInterests">
    <p :class="minified ? 'mb-1' : 'mb-1 sm:mb-2'" :variant="minified ? '4' : '2'">
      <strong>{{ interestsTitle }}</strong>
    </p>

    <component
      :is="DynamicTagComponent"
      :highlighted="highlighted"
      :query-search-param="querySearchParam"
      :search-route-name="searchRouteName"
      :tags="interests"
      :tooltips="tooltips"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CTags from '@/components/ui/CTags.vue'
import CSearchTags from '@/components/ui/CSearchTags.vue'

interface Props {
  interests?: string[]
  tooltips?: Record<PropertyKey, string>
  highlighted?: any[]
  interestsTitle?: string
  searchRouteName?: string
  querySearchParam?: string
  minified?: boolean
  preview?: boolean
}

const props = defineProps<Props>()

// Dynamický výber komponentu
const DynamicTagComponent = computed(() => props.preview ? CTags : CSearchTags)
</script>